import { render, staticRenderFns } from "./CompetitionResponses.vue?vue&type=template&id=4c024ace&scoped=true"
import script from "./CompetitionResponses.vue?vue&type=script&lang=js"
export * from "./CompetitionResponses.vue?vue&type=script&lang=js"
import style0 from "./CompetitionResponses.vue?vue&type=style&index=0&id=4c024ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c024ace",
  null
  
)

export default component.exports